import styled from "styled-components";
import { ValidationStepContainer } from "../../checkoutRoutes/validationStep/validationStep.style";

export const UserLogoutContainer = styled(ValidationStepContainer)`
  min-height: calc(100vh - 24rem);
`;
